<template>
    <div class="home">
        <v-alert
            class="alert"
            v-model="alert"
            dismissible
            color="error"
            icon="mdi-alert-circle"
            transition="slide-x-reverse-transition"
            dark
        >
            Erro ao encontrar sua conta no servidor!
        </v-alert>
        <v-container fluid fill-height>
            <v-row align="center" justify="center">
                <v-col class="text-center">
                    <v-card
                        class="mx-auto"
                        max-width="500"
                        style="border-radius: 10px"
                        :dark="customization.dark"
                    >
                        <v-img
                            class="white--text align-end"
                            height="125px"
                            :src="customization.logo"
                            style="background-color: transparent; border-radius: 5px" 
                        />
                        <v-card-subtitle class="pb-0">Seja bem vindo(a)! Informe seus dados para fazer o Login.</v-card-subtitle>
                        <v-row align="center" justify="center">
                            <v-col cols="10" md="4">
                                <v-text-field
                                    label="Conta"
                                    :rules="fieldRules"
                                    v-model="inputConta"
                                    id="conta_field"
                                    @keydown.enter="logar"
                                    outlined
                                ></v-text-field> 
                            </v-col>
                            <v-col cols="10" md="6" class="forms_input_mobile_index">
                                <v-text-field
                                    label="Usuário"
                                    :rules="fieldRules"
                                    v-model="inputUsuario"
                                    id="usuario_field"
                                    @keydown.enter="logar"
                                    outlined
                                ></v-text-field> 
                            </v-col>
                            <v-col cols="10" class="forms_input_mobile_index2">
                                <v-text-field
                                    label="Senha"
                                    type="password"
                                    :rules="fieldRules"
                                    v-model="inputSenha"
                                    id="senha_field"
                                    @keydown.enter="logar"
                                    outlined
                                ></v-text-field>
                                <v-checkbox
                                id="lembrar_field"
                                v-model="inputLembrar"
                                label="Lembrar dados de login"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                @click="logar"
                                :color="customization.mainBtnColor"
                            >
                                Entrar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <div style="position: fixed; bottom: 15px; text-align: center; width: 100%; opacity: .5">
                Versão do site: {{version}}
            </div>
        </v-container>
    </div>
</template>

<style scoped>
.alert{
    position: fixed; 
    right: 5px; 
    bottom: 5px; 
    max-width: 500px; 
    width: calc(100% - 10px); 
    z-index: 1000000;
}
.forms_input_mobile_index{
    transform: translateY(0px);
}
.forms_input_mobile_index2{
    transform: translateY(-30px);
}
@media screen and (max-width: 960px){
    .forms_input_mobile_index{
        transform: translateY(-25px)
    }
    .forms_input_mobile_index2{
        transform: translateY(-55px);
    }
}
.home{
    height: 100%;
    background-color: #28396b;
}
</style>

<script>
import api from '@/plugins/apisauce.js';
import apiHeader from '@/plugins/apisauceHeader.js';
import router from '@/router/index.js'

export default {
    name: 'Home',
    data: () => ({
        fieldRules: [
            r => (r && r.length > 0) || "Preencha esse campo."
        ],
        inputConta: null,
        inputUsuario: null,
        inputSenha: null,
        alert: false,
        inputLembrar: false,
        customization : {},
        version: null
    }),
    methods: {
        logar(){
            if(!this.inputConta)      return document.getElementById("conta_field").focus();
            if(!this.inputUsuario)    return document.getElementById("usuario_field").focus();
            if(!this.inputSenha)      return document.getElementById("senha_field").focus();

            api.post("/session",{
                account: this.inputConta,
                login: this.inputUsuario,
                senha: this.inputSenha
            }).then(r=>{
                if(r.ok) {
                    localStorage.setItem("usrId",r.data.user.usu_ID);
                    localStorage.setItem("login",r.data.user.login);
                    localStorage.setItem("idperfil",r.data.user.IDPERFIL);
                    localStorage.setItem("idcliente",r.data.user.IDCLIENTE);
                    localStorage.setItem("intervalo_posicoes", r.data.user.intervalo_posicoes ? r.data.user.intervalo_posicoes : 300);
                    localStorage.setItem("account",this.inputConta);
                    localStorage.setItem("nome",r.data.user.Nome);
                    localStorage.setItem("token",r.data.token);

                    if(this.inputLembrar){
                        localStorage.setItem("contaSave",this.inputConta);
                        localStorage.setItem("usuarioSave",this.inputUsuario);
                    }else{
                        localStorage.removeItem("contaSave");
                        localStorage.removeItem("usuarioSave");
                    }

                    apiHeader(localStorage.getItem("token")).get(`/menu/${localStorage.getItem("idcliente")}/${localStorage.getItem("idperfil")}`).then(r=>{
                        localStorage.setItem("menu",JSON.stringify(r.data));
                    });

                    router.push('dashboard');
                }else this.alert = true;
            })
        },
        findGetParameter(parameterName) {
            var result = null,
                tmp = [];
            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
                });
            return result;
        }
    },
    mounted(){
        document.title = "BrasilTrack - Login";
        const params = this.findGetParameter("s");
        if(params){
            api.get(`/setting/${params}`).then(r=>{
                const custom = r.data.json ? JSON.parse(r.data.json) : {};
                custom.dark = custom.dark ? custom.dark : false;
                custom.backgroundColor = custom.backgroundColor ? custom.backgroundColor : '#f2f2f2';
                custom.topBarColor = custom.topBarColor ? custom.topBarColor : '#1e3987';
                custom.leftMenuColor = custom.leftMenuColor ? custom.leftMenuColor : '#25386e';
                custom.topBarTextColor = custom.topBarTextColor ? custom.topBarTextColor : 'white';
                custom.mainBtnColor = custom.mainBtnColor ? custom.mainBtnColor : 'green';
                custom.logo = custom.logo ? custom.logo : "https://myposweb.com/logo.png";
                custom.name = custom.name ? custom.name : 'BrasilTrack'

                document.title = custom.name + " - Login";
                this.customization = custom;
                localStorage.setItem("system",params);
                localStorage.setItem("customization",JSON.stringify(custom));
            })
        }else{
            if(localStorage.getItem("customization")){
                const custom = JSON.parse(localStorage.getItem("customization"));
                document.querySelector(".home").style.backgroundColor = custom.backgroundColor;
                document.title = custom.name + " - Login";
                this.customization = custom;
                localStorage.setItem("customization",JSON.stringify(custom));
            }
        }
        if(localStorage.getItem("usrId")) router.push('dashboard');
        if(localStorage.getItem("contaSave")){
            this.inputConta     = localStorage.getItem("contaSave");
            this.inputUsuario   = localStorage.getItem("usuarioSave");
            this.inputLembrar   = true;
        }

        this.version = window.mainApp.version;
    }
}
</script>
